let _ = t => t,
    _t;

import styled from 'styled-components';
import breakpoint, { breakpointValues } from 'pricing-pages-ui/js/constants/Breakpoints';
const ProductInfoContainer = styled.main.attrs({
  role: 'main'
}).withConfig({
  displayName: "ProductInfoContainer",
  componentId: "sc-11dizue-0"
})(["max-width:1130px;display:flex;flex-direction:column;align-items:center;width:100%;margin:0 18px;@media (min-width:", "px) and (max-width:", "px){max-width:1008px;}@media (min-width:", "px) and (max-width:", "px){max-width:776px;}@media (min-width:", "px) and (max-width:", "px){max-width:650px;margin:0 10px;}", ";"], breakpointValues.sdMac, breakpointValues.sd - 1, breakpointValues.tablet, breakpointValues.sdMac - 1, breakpointValues.tabletPortrait, breakpointValues.tablet - 1, breakpoint.tabletPortrait(_t || (_t = _`
    padding-top: 20px;
    margin: 0 auto;
  `)));
export default ProductInfoContainer;